export default __webpack_public_path__ + "static/media/poster.2706ae52.webp";